import './style.scss'
import { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
//import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { AppText, FixedContainer, FlexRow, GridContainer, Circle, Icon, CustomContainer, AppSpan } from "src/style"
import { VscBell } from 'react-icons/vsc'
import { HiOutlineChevronDown } from 'react-icons/hi'
import ProfilePics from 'src/assets/img/profile-pics.svg'
import { DisputeSearch, Notification } from 'src/popup'
import utility from 'src/utils/utility'
import { BiMenuAltLeft } from 'react-icons/bi'


export const Header: React.FC = () => {
    const location = useLocation()
    //const {info: {searchedUserInfo}} = useContext(AppInfoContext)
    const [isNotification, setIsNotification] = useState(false)
    const [isDisputeSearch, setIsDisputeSearch] = useState(false)
    const [title, setTitle] = useState('Overview')

    useEffect(() => {
        setTitle(utility.getPageTitle());

        return () => { }
    }, [location])
    
    return (
        <>
            <FixedContainer 
                top="0" left="0" width="100" sizeUnit="%"
                bgColor="#ffffff" zIndex="4"
            >
                <GridContainer 
                    height="5.7" bgColor="#ffffff" leftPadding="23"
                    style={{borderBottom: "1px solid #E2E8F0"}}
                >
                    <FlexRow justifyContent='space-between' leftPadding='2.5' rightPadding='2.5'>
                        <FlexRow width='auto' sizeUnit=''>
                            { title === 'Dispute_request' &&
                                <AppSpan 
                                    textSize='2.5' color='#718096' rightMargin='2' cursor='pointer'
                                    onClick={() => setIsDisputeSearch(true)}
                                >
                                    <BiMenuAltLeft />
                                </AppSpan>
                            }
                            <AppText textSize='1.6' color='#000000' fontWeight='600'>{title === 'Dispute_request' ? 'Dispute & Request' : title}</AppText>
                        </FlexRow>
                        <FlexRow width='auto' sizeUnit=''>
                            <VscBell className='notif-icon' onClick={() => setIsNotification(true)} />
                            <Circle size='3' leftMargin='3'>
                                <Icon noResize minWidth='100' style={{objectFit: 'cover'}} src={ProfilePics} />
                            </Circle>
                            <CustomContainer width='auto' sizeUnit='' leftMargin='1'>
                                <AppSpan cursor='pointer'>Ridwaan</AppSpan>
                                <AppSpan cursor='pointer' leftPadding='0.5'>
                                    <HiOutlineChevronDown/>
                                </AppSpan>
                            </CustomContainer>
                        </FlexRow>
                    </FlexRow>
                </GridContainer>
            </FixedContainer>
            { isNotification &&
                <Notification 
                    close={() => setIsNotification(false)}
                />
            }
            { isDisputeSearch &&
                <DisputeSearch
                    close={() => setIsDisputeSearch(false)}
                />
            }
        </>
    )
}